import {ServiceRequestFormTitle} from '../genericComponents/ServiceRequestFormTitle'
import React, {useState} from 'react'
import {ServiceRequestTemplate} from '../genericComponents/structure/ServiceRequestTemplate'
import {ServiceRequestHeader} from '../genericComponents/structure/ServiceRequestHeader'
import {useCurrentGuildContext, useDatxPathGenerator} from '../../../util/routing'
import {ROUTES} from '../../../constants/routing'
import ItemTypeChip from '../../../item/ItemTypeChip'
import {ItemTypeEnum} from '../../../item/model/ItemType'
import {useGetGuildQuery} from '../../../guild/rtkGuildApi'
import {getServiceName, ServiceEnum} from '../../model/ServiceEnum'
import TimesOneMobiledataIcon from '@mui/icons-material/TimesOneMobiledata'
import {NewItemServiceRequestChoiceCard} from './NewItemServiceRequestChoiceCard'
import {Link} from 'react-router-dom'
import {ServiceRequestBody} from '../genericComponents/structure/ServiceRequestBody'
import {Description} from '../../../genericComponents/typographie/Description'
import {Button, RadioGroup} from '@mui/material'
import './SelectNewItemRequestType.scss'
import {ServiceRequestFooter} from '../genericComponents/structure/ServiceRequestFooter'

enum ItemCreationQuantity {
    SINGLE_ITEM = 'SINGLE_ITEM',
    BULK = 'BULK'
}

const ITEM_TYPE = 'item-type'
const CREATION_QUANTITY = 'creation-quantity'

export const SelectNewItemRequestType = () => {
    const generatePath = useDatxPathGenerator()
    const [currentGuildContext] = useCurrentGuildContext()
    const {data: guild} = useGetGuildQuery(currentGuildContext?.guildId, {skip: !currentGuildContext?.guildId || !currentGuildContext?.guildAdmin})
    const [selectedItemType, setSelectedItemType] = useState<ItemTypeEnum | null>(null)
    const [selectedQuantityType, setSelectedQuantityType] = useState<ItemCreationQuantity | null>(null)


    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = event.target
        if (name === ITEM_TYPE) {
            setSelectedItemType(value as ItemTypeEnum)
        }
        if (name === CREATION_QUANTITY && selectedItemType !== null) {
            setSelectedQuantityType(value as ItemCreationQuantity)
        }
    }

    return <ServiceRequestTemplate className="new-item">

        <ServiceRequestHeader>
            <ServiceRequestFormTitle title="Request New Item Creation"
                                     previousUrl={generatePath(ROUTES.servicesCatalogue.path)}/>
        </ServiceRequestHeader>

        <ServiceRequestBody className="service-request-choice-card-container">
            <div className="service-request-choice-card-container-body">
                <Description className="step-description">Select the <b> Item Type</b></Description>
                <RadioGroup name={ITEM_TYPE} className="service-request-choice-cards" onChange={handleChange}
                            value={selectedItemType}>
                    <NewItemServiceRequestChoiceCard id={`${getServiceName(ServiceEnum.NEW_MANUFACTURER_ITEMS)}`}
                                                     icon={<ItemTypeChip itemTypeLabel={ItemTypeEnum.MANUFACTURER}/>}
                                                     description="Items in the catalogue of a Manufacturer"
                                                     value={ItemTypeEnum.MANUFACTURER}
                                                     isActive={ItemTypeEnum.MANUFACTURER === selectedItemType}
                    />
                    <NewItemServiceRequestChoiceCard id={`${getServiceName(ServiceEnum.NEW_COMPANY_ITEMS)}`}
                                                     icon={<ItemTypeChip itemTypeLabel={ItemTypeEnum.COMPANY}/>}
                                                     description="Items that represent a Manufacturer item with your own company identification"
                                                     value={ItemTypeEnum.COMPANY}
                                                     isActive={ItemTypeEnum.COMPANY === selectedItemType}
                    />
                </RadioGroup>
            </div>
        </ServiceRequestBody>

        <ServiceRequestBody className="service-request-choice-card-container">
            <div className="service-request-choice-card-container-body">
                <Description>Select the <b> Creation Quantity</b></Description>
                <RadioGroup name={CREATION_QUANTITY} onChange={handleChange} value={selectedQuantityType}
                            className="service-request-choice-cards">
                    <NewItemServiceRequestChoiceCard id={`quantity-${ItemCreationQuantity.SINGLE_ITEM}`}
                                                     title="Single Item"
                                                     icon={<TimesOneMobiledataIcon className="create-quantity-icon"/>}
                                                     description={<span>I want to create just <span
                                                         className="text-underline">ONE</span> item</span>}
                                                     isActive={ItemCreationQuantity.SINGLE_ITEM === selectedQuantityType}
                                                     isDisabled={selectedItemType === null}
                                                     value={ItemCreationQuantity.SINGLE_ITEM}
                    />
                    <NewItemServiceRequestChoiceCard id={`quantity-${ItemCreationQuantity.BULK}`}
                                                     title="BULK"
                                                     icon={<img alt="bulk-icon" src="/images/custom-icons/Bulk.svg"
                                                                className="create-quantity-icon"/>}
                                                     description={<span>I want to create a <span
                                                         className="text-underline">BUNCH</span> of items</span>}
                                                     value={ItemCreationQuantity.BULK}
                                                     isActive={ItemCreationQuantity.BULK === selectedQuantityType}
                        isDisabled={selectedItemType === null}
                    />
                </RadioGroup>
            </div>
        </ServiceRequestBody>

        <ServiceRequestFooter>
            <Button data-testid="stepper-next"
                    className="service-request-form-submit"
                    disabled={!(selectedItemType && selectedQuantityType)}
                    component={Link} color="primary" variant="contained"
                    to={selectedItemType===ItemTypeEnum.MANUFACTURER?
                        generatePath(ROUTES.newManufacturerPartsServiceForm.path):
                        generatePath(ROUTES.newCompanyPartsServiceForm.path)
            }>
                Start Request
            </Button>
        </ServiceRequestFooter>

    </ServiceRequestTemplate>
}
